"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Signer = void 0;
const operators_1 = require("rxjs/operators");
const trade_utils_lib_1 = require("trade_utils_lib");
const struct_1 = require("../struct");
class Signer {
    constructor(clientTradingTokenManager) {
        this.recvTimestamp = 0;
        this.clientTradingTokenManager = clientTradingTokenManager;
    }
    init() {
        this.updateRecvTimestamp();
    }
    updateRecvTimestamp() {
        (0, trade_utils_lib_1.requestWithRetry)(() => {
            return trade_utils_lib_1.Network.get({
                url: `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().publicApiHost}/timestamp/`,
                headers: { "Cache-Control": "no-cache" },
            }).pipe((0, operators_1.map)((data) => {
                return Date.now() - data.timestamp;
            }));
        }).subscribe({
            next: (data) => {
                this.recvTimestamp = data;
            },
            error: (error) => {
                console.log(`${error}`);
            }
        });
    }
    getTradeParams(method, fullPath, body, tokenType = struct_1.TradeTokenType.spot) {
        let urlWithCommonParam = trade_utils_lib_1.ObservableUtils.buildUrlWithCommonParams(fullPath, (0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().commonParam);
        return this.clientTradingTokenManager.requestTradingBotToken().pipe((0, operators_1.map)((tokenInfo) => {
            const [token, apiSecret] = (() => {
                switch (tokenType) {
                    case struct_1.TradeTokenType.swap:
                        if (!tokenInfo.swapToken) {
                            throw { code: -1, message: "terminal not find swap token => token lib" };
                        }
                        return [tokenInfo.swapToken, tokenInfo.swapApiSecret];
                    case struct_1.TradeTokenType.trader:
                        if (!tokenInfo.traderToken) {
                            throw { code: -1, message: "terminal not find future_perp token => token lib" };
                        }
                        return [tokenInfo.traderToken, tokenInfo.traderApiSecret];
                    default:
                        if (!tokenInfo.tradingToken) {
                            throw { code: -1, message: "terminal not find spot token => token lib" };
                        }
                        return [tokenInfo.tradingToken, tokenInfo.apiSecret];
                }
            })();
            const timestamp = new Date().getTime() - this.recvTimestamp;
            const urlWithoutSuffix = urlWithCommonParam.startsWith("https") ? urlWithCommonParam.slice(8) : urlWithCommonParam;
            const hostEndPos = urlWithoutSuffix.indexOf("/");
            const urlParamWithoutHost = urlWithoutSuffix.slice(hostEndPos);
            return {
                access_token: tokenInfo.awsToken,
                timestamp: timestamp,
                signature: method === "GET" || method === "DELETE"
                    ? (0, trade_utils_lib_1.hmac)(`${method}${urlParamWithoutHost}${timestamp}`, apiSecret, "sha256", "base64")
                    : (0, trade_utils_lib_1.hmac)(`${method}${urlParamWithoutHost}${body}${timestamp}`, apiSecret, "sha256", "base64"),
                spot_token: tokenInfo.tradingToken,
                swap_token: tokenInfo.swapToken,
                trader_token: tokenInfo.traderToken,
                Authorization: token,
            };
        }));
    }
    getSignRequest(method, path, body) {
        let urlWithCommonParam = trade_utils_lib_1.ObservableUtils.buildUrlWithCommonParams(`${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().TRADE_RPC_HOST}${path}`, (0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().commonParam);
        let signUrlWithCommonParam = urlWithCommonParam;
        const signHost = (0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().TRADE_RPC_SIGN_HOST;
        if (signHost) {
            signUrlWithCommonParam = trade_utils_lib_1.ObservableUtils.buildUrlWithCommonParams(`${signHost}${path}`, (0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().commonParam);
        }
        return this.clientTradingTokenManager.requestTradingBotToken().pipe((0, operators_1.map)((tokenInfo) => {
            let timestamp = new Date().getTime() - this.recvTimestamp;
            return {
                Authorization: tokenInfo.awsToken,
                "Trade-Token": tokenInfo.tradingToken,
                Timestamp: timestamp,
                Signature: method === "GET"
                    ? (0, trade_utils_lib_1.hmac)(`${method}${signUrlWithCommonParam}${timestamp}`, tokenInfo.apiSecret, "sha256", "base64")
                    : (0, trade_utils_lib_1.hmac)(`${method}${signUrlWithCommonParam}${body}${timestamp}`, tokenInfo.apiSecret, "sha256", "base64"),
            };
        }), (0, operators_1.mergeMap)((headers) => {
            if (method === "GET") {
                return trade_utils_lib_1.ObservableUtils.createGetRequestObservable(urlWithCommonParam, headers, (response) => {
                    return response;
                });
            }
            else if (method === "POST") {
                return trade_utils_lib_1.ObservableUtils.createPostRequestObservable(urlWithCommonParam, headers, body, (response) => {
                    return response;
                });
            }
            else {
                throw `${method} is not supported`;
            }
        }));
    }
    getSignRequestV2(method, fullPath, body, tokenType = struct_1.TradeTokenType.spot) {
        let urlWithCommonParam = trade_utils_lib_1.ObservableUtils.buildUrlWithCommonParams(fullPath, (0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().commonParam);
        return this.getTradeParams(method, fullPath, body, tokenType).pipe((0, operators_1.map)((headerParams) => {
            return {
                Authorization: `Bearer ${headerParams.Authorization}`,
                Timestamp: headerParams.timestamp,
                Signature: headerParams.signature,
            };
        }), (0, operators_1.mergeMap)((headers) => {
            if (method === "GET") {
                return trade_utils_lib_1.ObservableUtils.createGetRequestObservable(urlWithCommonParam, headers, (response) => {
                    return response;
                });
            }
            else if (method === "POST") {
                return trade_utils_lib_1.ObservableUtils.createPostRequestObservable(urlWithCommonParam, headers, body, (response) => {
                    return response;
                });
            }
            else if (method === "DELETE") {
                return trade_utils_lib_1.ObservableUtils.createDeleteRequestObservable(urlWithCommonParam, headers, (response) => {
                    return response;
                });
            }
            else {
                throw `${method} is not supported`;
            }
        }));
    }
}
exports.Signer = Signer;
